const e = "style-module__fileIconContainer___j4adA", n = {
  fileIconContainer: e
};
export {
  n as default,
  e as fileIconContainer
};
